export default "https://app.draftstars.com.au/FantasyInsider-5d06021674be7c20c6730372b17bae64.gif";